module.exports = __webpack_public_path__ + "static/media/8_of_hearts.c1fff4ad.png";